import ModalInfo from 'components/templates/modalInfo/ModalInfo';
import Button from 'components/commons/buttons/button/Button';

import './modalDelete.scss';
import { useTranslate } from 'context/languageContext';

export default function ModalDelete({ onClose, onAccept, text = '', title = '' }) {
  const t = useTranslate();

  return (
    <ModalInfo closeAction={() => onClose()} width='350px' height='auto' title={title}>
      <div className='modal-success'>
        <div className='modal-success-text'>{text}</div>
        <div className='modal-success-actions'>
          <Button
            title={t('lb_cancelar')}
            className='modal-success-btn-cancelar'
            onClick={() => onClose()}
          />
          <Button
            title={t('lb_aceptar')}
            className='modal-success-btn-aceptar'
            onClick={() => onAccept()}
          />
        </div>
      </div>
    </ModalInfo>
  );
}
